export default "__VITE_ASSET__195db387__"